module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-9@3x__edac60fe3aab102907645d40aa1b64c2.png";